module.exports = __webpack_public_path__ + "static/rigo-1812dec57a85eae1a022de6d5e6affe7.jpg";